<div [ngClass]="{ active: active, disabled: disabled, hoverable: hoverable }" class="default-item-container default-item-container--blue">
  <div class="content-container">
    <div class="default-item-top-container">
      <div class="default-title">{{ item?.title }}</div>
    </div>
    <div class="default-item-bottom-container">
      <div class="label-span flex-1">
        <label>{{ "template.item.assignedTo" | translate }}</label>
        <span>{{ item?.orgCode || item?.responsibleType }}</span>
      </div>
    </div>
  </div>

  <div class="default-item-buttons">
    @if (!disabled && !readonly && editable) {
      <button (click)="$event.stopPropagation(); edit.emit(item)" class="icon-button icon-button--snowy" type="button">
        <fa-icon [icon]="['fas', 'pen']"></fa-icon>
      </button>
    }
    <button (click)="$event.stopPropagation(); preview.emit(item)" class="icon-button icon-button--snowy" type="button">
      <fa-icon [icon]="['fas', 'search']"></fa-icon>
    </button>
    @if (!disabled && !readonly && deletable) {
      <button (click)="$event.stopPropagation(); clear.emit()" class="icon-button icon-button--danger" type="button">
        <fa-icon [icon]="['fas', 'trash-alt']"></fa-icon>
      </button>
    }
  </div>
</div>
